<template>
  <div class="delkkyz-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-title">
            扣款验证列表
            <el-button type="primary" @click="addTel" class="add-btn" icon="el-icon-plus">添加号码</el-button>
            <div class="search-mode">
              <input type="text" class="search-input" @keyup.enter="Search" placeholder="关键字搜索" v-model="searchTel" />
              <el-button class="search-btn" icon="el-icon-search" @click="SearchTel"/>
            </div>
          </div>
          <div class="card-content" >
            <el-row>
              <el-col :span="24" v-loading="loadingTel">
                <el-table
                  :data="tableDataTel"
                  :show-header="false"
                  style="width: 100%">
                  <el-table-column
                    label="姓名"
                    width="180"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#99a9bf">姓名：</span>
                      <span>{{scope.row.name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="电话号码"
                    width="280"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#99a9bf">电话号码：</span>
                      <span>{{scope.row.tel}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作">
                    <template slot-scope="scope">
                      <el-dropdown size="mini" @click="editTel(scope.row)" split-button icon="el-icon-edit">
                        <i class="el-icon-edit"></i> 编辑
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item @click.native="delTel(scope.row)" style="color:#F56C6C"><i class="el-icon-delete"></i> 删除号码</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="totalTel>0"
                  background
                  @size-change="handleSizeChangeTel"
                  @current-change="handleCurrentChangeTel"
                  :current-page="currentPageTel"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSizeTel"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="totalTel">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editTelTitle"
      :visible.sync="editTelVisible"
      width="30%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="telForm" :model="telForm" :rules="telRules"  label-position="right" label-width="75px" size="small">
        <el-form-item label="姓名" prop="name">
          <el-input
            maxlength="10"
            v-model="telForm.name">
          </el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="tel">
          <el-input
            v-model="telForm.tel"
            minlength="11"
            maxlength="11">
          </el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editTelloading" @click="subEditTel('telForm')">立即提交</el-button>
          <el-button @click="editTelVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getDealerTelList, editDealerTel } from '@/api/work'
import { validatePhoneNumber } from '@/utils/validate'

export default {
  name: 'delkkyz',
  computed: {
    user: getUser
  },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!validatePhoneNumber(value)) {
        callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }
    return {
      editTelloading: false,
      searchTel: '',
      loadingTel: false,
      tableDataTel: [],
      currentPageTel: 1,
      pageSizeTel: 20,
      totalTel: 0,
      editTelVisible: false,
      editTelTitle: '添加扣款验证号码',
      telForm: {
        dtid: null,
        name: '',
        tel: ''
      },
      telRules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        tel: [{ required: true, trigger: 'blur', validator: validateUsername }]
      }
    }
  },
  created() {
    this.getTelData()
  },
  methods: {
    SearchTel() {
      if (this.searchTel != null && this.searchTel.trim() != '') {
        this.currentPageTel = 1
        this.getTelData()
      } else {
        this.searchTel = ''
        this.getTelData()
      }
    },
    getTelData() {
      this.loadingTel = true
      const data = {
        delid: this.user.delid,
        content: this.searchTel,
        page: this.currentPageTel,
        limit: this.pageSizeTel
      }
      getDealerTelList(data).then(response => {
        this.loadingTel = false
        this.tableDataTel = response.data
        this.totalTel = response.total
      }).catch(() => {
        this.loadingTel = false
      })
    },
    handleSizeChangeTel(val) {
      this.pageSizeTel = val
      this.getTelData()
    },
    handleCurrentChangeTel(val) {
      this.currentPageTel = val
      this.getTelData()
    },
    addTel() {
      this.editTelTitle = '添加扣款验证号码'
      this.telForm.dtid = null
      this.telForm.name = ''
      this.telForm.tel = ''
      this.editTelVisible = true
    },
    editTel(row) {
      this.editTelTitle = '编辑扣款验证号码'
      this.telForm.dtid = row.dtid
      this.telForm.name = row.name
      this.telForm.tel = row.tel
      this.editTelVisible = true
    },
    delTel(row) {
      this.$confirm('删除 “' + row.name + '” 扣款验证号码, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        editDealerTel({ dtid: row.dtid, type: 2 }).then(response => {
          this.$message({
            message: response.msg,
            type: 'success'
          })
          this.getTelData()
        }).catch(() => {})
      }).catch(() => {})
    },
    subEditTel(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editTelloading) {
            this.editTelloading = true
            let data = {}
            if (this.telForm.dtid != null) {
              data = {
                dtid: this.telForm.dtid,
                delid: this.user.delid,
                name: this.telForm.name,
                tel: this.telForm.tel,
                type: 1
              }
            } else {
              data = {
                delid: this.user.delid,
                name: this.telForm.name,
                tel: this.telForm.tel,
                type: 0
              }
            }
            editDealerTel(data).then(response => {
              this.$message({
                message: response.msg,
                type: 'success'
              })
              this.editTelVisible = false
              this.editTelloading = false
              this.getTelData()
            }).catch(() => {
              this.editTelloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style  lang="scss" scoped>
.delkkyz-container{
  .add-btn{
    position: relative;
    float: right;
    margin-left: 10px;
    margin-top: -10px;
  }
  .search-mode{
    width: 300px;
    position: relative;
    float: right;
    margin-top: -10px;
    .search-input{
      background-color: #F2F6FC;
      border:0;
      height: 40px;
      line-height: 40px;
      border-radius: 4px;
      color: #606266;
      padding: 0 40px 0 15px;
      -webkit-appearance: none;
      font-size: 12px;
      width: 100%;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      outline: 0;
      &::-webkit-input-placeholder {
       color: #C0C4CC;
      }
      &::-ms-input-placeholder {
       color: #C0C4CC;
      }
    }
    .search-btn{
      position: absolute;
      right: 0;
      height: 40px;
      width: 40px;
      line-height: 40px;
      top: 0;
      border: 0;
      background: transparent;
      text-align: center;
      padding: 0;
    }
  }
  .card-content{
    .user-sex{
      width: 16px!important;
      height: 16px!important;
      vertical-align: -4px!important;
    }
    .el-table::before{
      height: 0!important;
    }
    .el-pagination{
      margin-top: 20px;
    }
  }
}
</style>
